/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */
import React from "react";
import CustomGenericTittleIconDataChip from "../../../../../../../../components/CustomGenericTittleIconDataChip";
import CustomChip from "../../../../../../../../components/CustomChip";
import CustomTooltip from "../../../../../../../../components/CustomTooltip";
import {statusBorderColor, statusColor, statusFontColor} from "../../../../../../../../enums/statusColorEnum";
import {status} from "../../../../../../../../enums/statusEnum";
import {IconDocumentPencilEdit} from "../../../../../../../../components/buttons/IconButtons";

/**
 * Header of the card that holds the information of the folio: the title that
 * names it and the status it is read in.
 *
 * @param {Function} t - Translation handler.
 * @param {number} statusId - Status the folio is read in.
 * @param {Object} style - Style of the header, given by the status.
 * @param {React.Component} Icon - Icon that names the card.
 */
const DetailsCardHeader = ({t, statusId, style, Icon = IconDocumentPencilEdit}) => {
    return (
        <div className='d-flex justify-content-between align-items-center h-72px' style={style}>
            <div className={"mr-3"}>
                <CustomGenericTittleIconDataChip
                    title={'request_details'}
                    Icon={Icon}
                    border={false}
                    titleBoxClass={'d-flex'}
                />
            </div>

            <CustomChip
                variant={'large'}
                background={statusColor[statusId]}
                fontColor={statusFontColor[statusId]}
                borderColor={statusBorderColor[statusId]}
                legend={
                    <CustomTooltip
                        text={t(status[statusId])}
                        classes={`fs-12px text-ellipsis-1-row`}
                        showIfTruncated={true}
                    />
                }
                className={"flex-grow-0 minw-0"}
            />
        </div>
    );
};

export default DetailsCardHeader;
